import { post_data } from "./functions";

export async function logout(e) {
  e.preventDefault();
  const form = new FormData();
  form.append(
    "data",
    JSON.stringify({
      function: "logout",
    })
  );
  try {
    const response = await post_data("./includes/ajax.inc.php", form);
    window.location.href = "./index";
  } catch {
    window.location.href = "./index";
  }
}
